module.exports = __webpack_public_path__ + "img/seaspotter-logo.03d0a3ce.png";